import { useNavigate } from 'react-router-dom';
import useWorkspaces from '../../hooks/useWorkspaces';
import useDisclosure from '../../hooks/useDisclosure';
import { paths } from '../../routes/paths';
import Button from '../../components/ui/Button/Button';
import Icon from '../../components/ui/Icon/Icon';
import CreateWorkspaceModal from '../../components/workspace/CreateWorkspaceModal/CreateWorkspaceModal';
import styles from './WorkspacesPage.module.css';

const ASCII_NEST = `   .--.   .--.
   |  '-'  |
   |       |
   '-------'`;

// Landing/welcome. Workspace navigation + creation live in the left rail.
export default function WorkspacesPage() {
  const { workspaces, loading, createWorkspace } = useWorkspaces();
  const navigate = useNavigate();
  const createModal = useDisclosure();

  const handleCreate = async (name) => {
    const id = await createWorkspace(name);
    navigate(paths.workspace(id));
  };

  const hasWorkspaces = workspaces.length > 0;

  return (
    <div className={styles.welcome}>
      <span className={styles.kicker}>sabia / workspaces</span>
      <h1 className={styles.title}>
        {hasWorkspaces ? 'BACK TO THE GRIND' : 'WELCOME TO THE NEST'}
      </h1>
      <div className={styles.divider} />
      <p className={styles.lead}>
        {loading
          ? '> hunting down your workspaces...'
          : hasWorkspaces
          ? '> pick a workspace from the left rail to jump back into your world. or spawn a new one.'
          : '> ready to write an epic? create your first workspace, or get an admin to invite you.'}
      </p>

      <div className={styles.actions}>
        <Button leftIcon={<Icon name="Plus" size={14} />} onClick={createModal.open}>
          Spawn workspace
        </Button>
      </div>

      <pre className={styles.ascii} aria-hidden="true">{ASCII_NEST}</pre>

      <CreateWorkspaceModal
        isOpen={createModal.isOpen}
        onClose={createModal.close}
        onCreate={handleCreate}
      />
    </div>
  );
}
